import keyMirror from 'keymirror'

export default keyMirror({
  GET_LIST_FIRMWARE_VERSION_PERS_REQUEST: null,
  GET_LIST_FIRMWARE_VERSION_PERS_SUCCESS: null,
  GET_LIST_FIRMWARE_VERSION_PERS_FAILED: null,

  GET_DETAIL_FIRMWARE_VERSION_PERS_REQUEST: null,
  GET_DETAIL_FIRMWARE_VERSION_PERS_SUCCESS: null,
  GET_DETAIL_FIRMWARE_VERSION_PERS_FAILED: null,

  DELETE_FIRMWARE_VERSION_PERS_REQUEST: null,
  DELETE_FIRMWARE_VERSION_PERS_SUCCESS: null,
  DELETE_FIRMWARE_VERSION_PERS_FAILED: null,

  ADD_FIRMWARE_VERSION_PERS_REQUEST: null,
  ADD_FIRMWARE_VERSION_PERS_SUCCESS: null,
  ADD_FIRMWARE_VERSION_PERS_FAILED: null,

  UPDATE_FIRMWARE_VERSION_PERS_REQUEST: null,
  UPDATE_FIRMWARE_VERSION_PERS_SUCCESS: null,
  UPDATE_FIRMWARE_VERSION_PERS_FAILED: null,

  REGENERATE_UUID_FIRMWARE_VERSION_PERS_REQUEST: null,
  REGENERATE_UUID_FIRMWARE_VERSION_PERS_SUCCESS: null,
  REGENERATE_UUID_FIRMWARE_VERSION_PERS_FAILED: null,

  REGENERATE_SEGMENTS_FIRMWARE_VERSION_PERS_REQUEST: null,
  REGENERATE_SEGMENTS_FIRMWARE_VERSION_PERS_SUCCESS: null,
  REGENERATE_SEGMENTS_FIRMWARE_VERSION_PERS_FAILED: null,

  GET_SYSTEM_FIRMWARE_VERSION_PERS_REQUEST: null,
  GET_SYSTEM_FIRMWARE_VERSION_PERS_SUCCESS: null,
  GET_SYSTEM_FIRMWARE_VERSION_PERS_FAILED: null,

  DOWNLOAD_FIRMWARE_VERSION_PERS_REQUEST: null,
  DOWNLOAD_FIRMWARE_VERSION_PERS_SUCCESS: null,
  DOWNLOAD_FIRMWARE_VERSION_PERS_FAILED: null
})
